// src/listeners/ActiveSessionListener.ts
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import useStore from "@src/stores/store";
import {db} from "@src/services/db";
import "@src/services/echo";
import MessageService from "@src/services/message";

export const ActiveSessionListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const store = useStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets.private(`user.${userId}`).listen(".NewActiveSession", async (event: any) => {
        const s = event?.session;
        if (!s?.id) return;

        const sid = Number(s.id);

        if (s.operator_id !== userId) {
            try {
                await db.transaction("rw", db.sessions, db.messages, async () => {
                    await db.messages.where("chat_session_id").equals(sid).delete();
                    await db.sessions.delete(sid);
                });

                // Se o atendimento estiver aberto, fecha a tela
                if (Number((sessionStore.selectedSession as any)?.id) === sid) {
                    sessionStore.clearSession();
                }
            } catch (e) {
                console.error("❌ erro ao deletar sessão de outro operador", e);
            }
            return;
        }

        try {
            const resp = await MessageService.getSessionMessagesOld(sid);
            let hasNewMessage = true

            const messages = Array.isArray(resp?.data)
                ? resp.data.map((message: any) => ({
                    ...message,
                    chat_session_id: Number(message.chat_session_id ?? sid),
                }))
                : [];

            if (Number((sessionStore.selectedSession as any)?.id) === sid && s.operator_id === userId) {
                store.activeSidebarComponent = "active";
                hasNewMessage = false
            }

            await db.transaction("rw", db.sessions, db.messages, async () => {
                if (messages.length > 0) {
                    await db.messages.bulkPut(messages);
                }

                await db.sessions.put({
                    ...s,
                    status: "active",
                    has_new_messages: hasNewMessage,
                    updated_at: new Date().toISOString(),
                } as any);
            });

        } catch (e) {
            console.error("❌ erro no listener NewActiveSession", e);
        }
    });
};